<template>
  <div class="t-avatar flex items-center">
    <span class="relative inline-block">
      <span
        class="rounded-full"
        :class="[VariantClasses[variant], SizeClasses[size]]"
      >
        <TLazyimg
          v-bind="imgProp"
          classes-img="object-cover w-full h-full t-card__img"
          classes="rounded-full"
        />
      </span>
    </span>

    <!-- TODO: talk about margin sizes: -->
    <div v-if="showTitlesContainer" class="ml-4 overflow-hidden grow">
      <TText :size="size" variant="semibold" clamp="clamp1" classes="mb-0">
        {{ title }}
      </TText>

      <TText
        color="text-gray-500"
        :size="size"
        variant="semibold"
        classes="mb-0 block truncate"
      >
        {{ subtitle }}
      </TText>
    </div>
  </div>
</template>

<script setup lang="ts">
// @ts-nocheck
import { computed } from 'vue'
import type { TLazyimg_Props } from '../t-lazyimg/constants/types'
import type { TAvatarVariant, TAvatarSize } from './constants/types'
import { VariantClasses, SizeClasses } from './constants/constants'

export interface TAvatar_Props {
  imgProp?: TLazyimg_Props
  variant?: TAvatarVariant
  size?: TAvatarSize
  title?: string
  subtitle?: string
}

const props = withDefaults(defineProps<TAvatar_Props>(), {
  variant: 'anonymous',
  size: 'md',
  title: '',
  subtitle: '',
})

const showTitlesContainer = computed(() => {
  return props.title || props.subtitle
})
</script>
